export const Conveyor = (() => {
	'use strict';

	let conveyors;

	function init() {
		conveyors = document.getElementsByClassName('conveyor');
		if (conveyors && conveyors.length > 0) {
			for (let conveyor of conveyors) {
				renderConveyor(conveyor);
				window.addEventListener(
					'resize',
					function (event) {
						renderConveyor(conveyor);
					},
					true
				);
			}
		}
	}

	function renderConveyor(el) {
		let windowWidth = window.innerWidth;
		let conveyorPerView = el.dataset.conveyorView ? el.dataset.conveyorView : 4;
		let conveyorSpeed = el.dataset.conveyorSpeed ? el.dataset.conveyorSpeed : 4;
		let conveyorTotal = el.children[0].children.length;
		let conveyorEnd =
			(windowWidth / conveyorPerView) * conveyorTotal -
			(windowWidth / conveyorPerView) * conveyorPerView;
		let conveyorReverse = el.dataset.conveyorReverse;

		el.children[0].setAttribute(
			'style',
			'width:' + (windowWidth / conveyorPerView) * conveyorTotal + 'px;'
		);
		el.children[0].animate(
			[
				{ transform: 'translateX(0)' },
				{
					transform:
						'translateX(' +
						(conveyorReverse !== undefined ? '' : '-') +
						conveyorEnd +
						'px)',
				},
			],
			{
				duration: parseInt(conveyorSpeed),
				iterations: Infinity,
			}
		);

		for (let i = 0; i < conveyorTotal; i++) {
			el.children[0].children[i].setAttribute(
				'style',
				'width:' + windowWidth / conveyorPerView + 'px'
			);
		}
	}

	return {
		init: init,
	};
})();
